import HomePages from './HomePages';
import ReferralFormChunk from '../../modules/InitChunks/ReferralFormChunk/ReferralFormChunk';
import ConfirmNewsletterChunk from '../../modules/InitChunks/ConfirmNewsletterChunk/ConfirmNewsletterChunk';

export default class Home extends HomePages {
  constructor() {
    super();

    // Add popin to referral form
    new ReferralFormChunk();

    // Confirm Newsletter
    Home.confirmRegister();
  }

  /*
   * Popin confirm register to Newsletter
   * */
  private static confirmRegister(): void {
    const newsletterConfirm: HTMLInputElement = document.querySelector(
      '.c-newsletter__confirmation'
    );

    if (newsletterConfirm) {
      new ConfirmNewsletterChunk();
    }
  }
}

new Home();
